<div class="container app app-box main-new">

  <div class="dark-map dark-no-sensors" [ngClass]="{'map-no-admin': Globals.hiddenAdmin}" *ngIf="dark_map">
    {{ 'no_sensors_in_project' | translate }}
  </div>

  <!-- loader -->
  <div id="page-preloader" *ngIf="!isDataAvailable">

    <div class="col-xs-12 stats-spinner-box">
      <div class="loading-pulse"></div>
    </div>

  </div>
  <!-- loader -->
  <menu *ngIf="Globals.user != undefined" class="menu-container">
    <app-menu></app-menu>
  </menu>
  <div *ngIf="!noaccess && !warning" class="main-content-box">

    <!-- help icon -->
    <div *ngIf="isDataAvailable" class="help-main" (click)="openhelp()"
      [ngClass]="{'map-control-padding': map_controls_padding_add}"></div>

    <!-- default scale icon -->
    <div *ngIf="isDataAvailable && touch_map" class="default-scale-icon" (click)="defaultScale()"
      [ngClass]="{'map-control-padding': map_controls_padding_add}"></div>


    <!-- map -->
    <div class="row map-container" *ngIf="!noaccess && !warning">
      <div id="map" #mapElement class="vt-bg" [ngClass]="{'map-no-admin': Globals.hiddenAdmin}"></div>
    </div>
    <!-- /map -->

    <!-- message line -->
    <div *ngIf="changed_sensors.length" class="message-line">
      <!-- <div class="message-line-in">
          <div>
              <b>{{ 'status_check' | translate }}:</b>
              {{check_status | date:'dd.MM.yyyy, HH:mm:ss'}}
          </div>
      </div> -->
      <div class="message-line-in">
        <div>
          <b>{{ 'status_change' | translate }}: {{status_change | date:'dd.MM.yyyy, HH:mm:ss'}}</b>
          <div *ngIf="changed_sensors_block_open" class="">
            <a class="changed_sensors" *ngFor="let sensor of changed_sensors; let i = index"
              (click)="goToSensor(sensor)" [ngClass]="{
              'sel-status-red':sensor.status_v === 0,
              'sel-status-green':sensor.status_v === 1,
              'sel-status-yellow':sensor.status_v === 2
          }" title="{{sensor.status_v_list}}">{{sensor.name}}
          <span *ngIf="i+1 != changed_sensors.length"> &nbsp;&nbsp; </span></a>
          </div>
        </div>
        <div class="sub-item-icon" [ngClass]="{'sub-icon-back':changed_sensors_block_open}"
          (click)="openGhangedSensors()"></div>
      </div>

    </div>
    <!-- /message line -->

    <!-- блок последнего события -->
    <div class="mf-last-block" [@last_show]="last_show" *ngIf="filter_both_show_inc">
      <div class="mf-last-block-bell" (click)="lastShow()" [ngClass]="{'mf-bell-ringing':blink_date}" id="bell_ring"></div>
      <div class="mf-last-block-content" *ngIf="last_show">
        <div *ngIf="last_event_loading" class="loading-pulse"></div>
        <div *ngIf="!last_event_loading">
          <div class="mf-last-block-head">
            <span>{{ 'new_event' | translate }}</span>
            <span>{{inc_last[0]?.start_time_new}}</span>
          </div>

          <div class="mf-last-block-name inc_li_red" [ngClass]="inc_last_class">
            {{inc_last_name}}
          </div>
          <div class="inc-popup-data">
            {{ 'speed' | translate }}: {{inc_last[0]?.obj_speed}} {{ 'kmH' | translate }}
          </div>
          <div class="inc-popup-data">
            {{ 'length' | translate }}: {{inc_last[0]?.obj_length}} {{ 'm' | translate }}
          </div>
          <div class="inc-popup-data">
            {{ 'lane' | translate }}: {{inc_last[0]?.lane}}
          </div>
          <div class="inc-popup-data">
            {{ 'sensor_name' | translate }}: «{{inc_last[0]?.sensor_name}}»
          </div>
          <div class="buttons-right inc-buttons">
            <button (click)="goToEvent(inc_last[0].events_id)" class="filter-btn-default">
              {{ 'go_to' | translate }}
            </button>
          </div>
        </div>
      </div>

    </div>
    <!-- /блок последнего события -->

    <!-- *** новый фильтр *** -->
    <div *ngIf="isDataAvailable && (filter_both_show_inc || filter_both_show)" class="multifilter"
      [@filters_show]="filters_show" [ngClass]="{'mf-border': !filters_show}">
      <!-- свернутый -->
      <div class="mf-min">

        <!-- иконка сбросить фильтры -->
        <div class="mf-reset-all" (click)="defaultFilter();resetIncFilter(false)">
          <!-- tooltip -->
          <span class="mf-tooltip">{{ 'clear_all_filters' | translate }}</span>
          <!-- tooltip -->
        </div>
        <!-- /иконка сбросить фильтры -->

        <div class="mf-icons-block-box">

          <div class="mf-icons-block" [ngClass]="{'mf-icons-block-en' : Globals.lang == 'en'}">
            <div *ngIf="filter_both_show_inc" class="mf-icon-events"
              [ngClass]="{'mf-active' : mf_events, 'mf-disabled': !eventsShow}" (click)="mfChange('events')">
              <a class="mf-icon">{{ 'last_events' | translate }}</a>
            </div>

            <div *ngIf="filter_both_show_inc && from_disabled_show_inc" class="mf-icon-filter-events"
              [ngClass]="{'mf-active' : mf_filter_events}" (click)="mfChange('filter_events')">
              <a class="mf-icon">{{ 'inc_filter' | translate }}</a>

              <!-- красная плашка при закрытии фильтра -->
              <ng-container *ngIf="params_number_inc > 0 && eventsByFilter">
                <!-- <ng-container> -->
                <span class="mf-sel-circle">
                  {{params_number_inc}}
                  <!-- tooltip -->
                  <span class="mf-events-tt">
                    <!-- кол-во -->
                    <span *ngIf="filterNumber == 1" class="mf-events-tt-line">
                      {{'event_quantity' | translate}}:
                      {{numberEvents}}
                    </span>
                    <!-- /кол-во -->
                    <!-- дата -->
                    <span *ngIf="filterDate == 1" class="mf-events-tt-line">
                      {{'period' | translate}}:
                      {{analisisService.dateBefore | date:'dd.MM.yyyy'}} – {{analisisService.dateAfter | date:'dd.MM.yyyy'}}
                    </span>
                    <!-- /дата -->
                    <!-- типы -->
                    <span *ngIf="filterTypes == 1" class="mf-events-tt-line">
                      {{'categories' | translate}}:
                      <span class="color-types">
                        <span *ngFor="let t of colorTypesSel" [style.backgroundColor]="t.color"></span>
                      </span>
                    </span>
                    <!-- типы -->
                  </span>
                  <!-- tooltip -->
                </span>
              </ng-container>
              <!-- /красная плашка при закрытии фильтра -->

            </div>

            <div *ngIf="filter_both_show" class="mf-icon-filter-sensors" [ngClass]="{'mf-active' : mf_filter_sensors}"
              (click)="mfChange('filter_sensors')">
              <a class="mf-icon">{{ 'sensor_filter' | translate }}</a>

              <!-- красная плашка при закрытии фильтра -->
              <ng-container *ngIf="fromfilter && sensor_select?.length < sensorProjectList?.length">
                <span class="mf-sel-circle">
                  {{this.sensor_select?.length}}
                  <!-- tooltip -->
                  <span class="mf-sensors-tt">
                    {{ 'shown' | translate }}: {{this.sensor_select?.length}}
                    {{ 'of' | translate}} {{sensorProjectList?.length}}
                  </span>
                  <!-- tooltip -->
                </span>
              </ng-container>
              <!-- /красная плашка при закрытии фильтра -->

            </div>
          </div>
        </div>
      </div>
      <!-- /свернутый -->

      <!-- развернутый -->
      <div *ngIf="mf_max_loading" class="loading-pulse"></div>
      <div *ngIf="mf_max_show" class="mf-max">

        <!-- вкладка списка событий -->
        <div class="mf-tab-events-list" *ngIf="mf_events && filter_both_show_inc">
          <div class="filter-box-head">{{ 'events_filter_title' | translate }}</div>

          <!-- выключатель -->
          <div class="can-toggle">
            <input [(ngModel)]="eventsShow" id="eventsShow" type="checkbox" (ngModelChange)="filterDisabled()">
            <label [attr.data-checked]="Globals.switch_on_lang" [attr.data-unchecked]="Globals.switch_off_lang" for="eventsShow">
              <div class="can-toggle__switch"></div>
            </label>
          </div>
          <!-- /выключатель -->

          <!-- чекбокс показывать с учетом фильтра -->
          <div *ngIf="eventsShow" class="mf-events-check-by-filter">
            <div class="checkbox">
              <input type="checkbox" [(ngModel)]="eventsByFilter" id="eventsByFilter"
                (ngModelChange)="eventsByFilterSwitch()">
              <label for="eventsByFilter">{{ 'events_by_filter' | translate }}</label>
            </div>
          </div>
          <!-- чекбокс показывать с учетом фильтра -->

          <!-- список событий -->
          <div *ngIf="eventsShow" class="mf-events-list">
            <div class="mf-events-list-box">

              <!-- событие -->
              <div class="mf-events-list-item" [ngClass]="{'mf-ev-sel-bg': ev_list_id == event.events_id}" *ngFor="let event of eventsFilterList | paginate: {itemsPerPage: 4, currentPage: p}, let i = index">

                <div class="mf-last-block-name" [ngClass]="event?.inc_class">
                  {{event?.inc_name}}
                </div>

                <div class="inc-popup-data">
                  {{ 'speed' | translate }}: {{event?.obj_speed}} {{ 'kmH' | translate }},
                  {{ 'length' | translate }}: {{event?.obj_length}} {{ 'm' | translate }}, {{ 'lane' |
                  translate }}:
                  {{event?.lane}}, {{ 'sensor_name' | translate }}: «{{event?.sensor_name}}»
                </div>

                <div class="mf-list-event-bottom">

                  <div class="mf-go-to-list-event" (click)="goToListEvent(event.events_id)"
                    [ngClass]="{'mf-ev-sel': ev_list_id == event.events_id}"></div>

                  <div class="mf-list-date">{{event?.start_time_new}}</div>

                </div>

              </div>
              <!-- /событие -->

            </div>

            <!-- нумерация -->
            <ng-container *ngIf="eventsShow">
              <pagination-controls (pageChange)="p = $event" maxSize="5" previousLabel nextLabel autoHide="true">
              </pagination-controls>
            </ng-container>
            <!-- /нумерация -->

          </div>
          <!-- /список событий -->

          <div class="mf-check-events-filtered"></div>
        </div>
        <!-- вкладка списка событий -->

        <!-- вкладка фильтра событий -->
        <div class="mf-tab-events-filter filter-box filter-inc-box" *ngIf="mf_filter_events && filter_both_show_inc">
          <div class="filter-box-head">{{ 'inc_filter' | translate }}</div>
          <div class="filter-box-selected">
            <div class="form-group">
              <div class="checkbox">
                <input type="checkbox" [(ngModel)]="eventsShow" id="eventsShow" (ngModelChange)="filterDisabled()">
                <label for="eventsShow">{{ 'show_events' | translate }}</label>
              </div>
              <div *ngIf="inc_num_sel_show" class="col-sm-4 projselect pull-right">
                <select [(ngModel)]="numberEvents" [disabled]="filterIncDisabled" class="form-control"
                  (ngModelChange)="changeNum = true">
                  <option *ngFor="let num of numberEventsList" [ngValue]="num">
                    {{num}}
                  </option>
                </select>
              </div>
            </div>
            <div class="filter-sep clearfix">{{ 'events_type' | translate }}</div>

            <!-- список типов -->
            <div class="inc-types-box">
              <div *ngIf="type_loading && !isDataAvailable" class="type-loading loading-pulse"></div>
              <div *ngFor="let t of filteredTypes;let i = index;" class="form-group">
                <div class="checkbox">
                  <input type="checkbox" [disabled]="filterIncDisabled" [(ngModel)]="t.checked" id="type{{i}}"
                    name="type{{i}}">
                  <label for="type{{i}}">{{ t.name[Globals?.lang] }}</label>
                </div>

                <!-- список подтипов -->
                <!-- <div *ngIf="t.checked" class="col-sm-4 pull-right inc-choose">
                    <button [disabled]="filterIncDisabled" (click)="showIncSubtipes(t)">{{ 'select' | translate }}</button>
                </div> -->

                <div [hidden]="!hideme[t.type]" class="inc-popup">

                  <div class="dialog-close-btn" (click)="hideme[t.type] = false">
                  </div>

                  <div class="inc_subtype" *ngFor="let p of t.subtypes;let in = index;">
                    <div class="checkbox">
                      <input type="checkbox" [disabled]="filterIncDisabled" [(ngModel)]="p.subtype_id"
                        id="subtype{{in}}">
                      <label for="subtype{{in}}" title="{{p[Globals?.lang]}}">
                        {{t.type}} {{p[Globals?.lang]}}
                      </label>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <!-- /список типов -->

            <!-- период -->
            <div class="filter-sep clearfix filter-sep-period">{{ 'period' | translate }}</div>

            <div class="date-time-box date-box">
              <div *ngIf="type_loading && !isDataAvailable" class="type-loading loading-pulse"></div>
              <div *ngIf="!eventsShow" class="inc-disabled"></div>
              <div *ngIf="!type_loading && isDataAvailable">

                <label for="inc_dateBefore" class="control-label">
                  {{ 'date_from' | translate }}
                </label>
                <div class="date-field" [ngClass]="{'input-invalid': analisisService.date_before_error}">
                  <app-date-time-picker
                    [(ngModel)]="analisisService.dateBefore"
                    name="inc_dateBefore"
                    (ngModelChange)="analisisService.correctPeriod(analisisService.dateBefore,analisisService.dateAfter)"
                    (catchInputDate)="catchInputDate($event)"
                    [report_date_type]=1>
                  </app-date-time-picker>
                </div>

                <label class="control-label">{{ 'date_to' | translate }}</label>
                <div class="date-field" [ngClass]="{'input-invalid': analisisService.date_after_error}">
                  <app-date-time-picker
                    [(ngModel)]="analisisService.dateAfter"
                    name="inc_dateAfter"
                    (ngModelChange)="analisisService.correctPeriod(analisisService.dateBefore,analisisService.dateAfter)"
                    (catchInputDate)="catchInputDate($event)"
                    [report_date_type]=2>
                  </app-date-time-picker>
                </div>

              </div>
            </div>
            <!-- /период -->

            <div class="buttons-right inc-buttons">
              <button (click)="resetIncFilter(true)" class="filter-btn-default">
                {{ 'default' | translate }}
              </button>
              <button [disabled]="filterIncDisabled || analisisService.date_before_error || analisisService.date_after_error" (keyup.enter)="applyIncfilter(true)" (click)="applyIncfilter(true)"
                class="button-active">
                {{ 'apply' | translate }}
              </button>
            </div>
          </div>
        </div>
        <!-- вкладка фильтра событий -->

        <!-- вкладка фильтра датчиков -->
        <div class="mf-tab-sensors-filter filter-box filter-box_not-hidden" *ngIf="mf_filter_sensors">
          <div class="filter-box-head">{{ 'sensor_filter' | translate }}</div>
          <div class="filter-box-selected">

            <!-- выбор датчика -->

            <div class="form-group" #droplist>
              <label class="control-label" for="code">
                {{ 'sensor_name' | translate }}
              </label>
              <ng-select
                [items]="sensorProjectList"
                class="custom sensor_select"
                [ngClass]="{ 'remove-padding': sensorProjectList.length < 2 }"
                bindLabel="name"
                bindValue="sensor_id"
                [multiple]="true"
                [closeOnSelect]="false"
                [selectOnTab]="true"
                placeholder="{{'select_sensor' | translate}}"
                notFoundText="{{'no_name_sensors' | translate}}"
                loadingText="{{'no_name_sensors' | translate}}"
                [(ngModel)]="sensor_select"
                (ngModelChange)="chooseSensor()"
                id="sensor_select"
                [loading]="true"
                (clear)="show_found = true"
                #getSensor="ngModel">
                <!-- custom option template -->
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div [title]="item.name" class="sensor-select-option" [ngClass]="{
                    'sel-status-red':item.status_v === 0,
                    'sel-status-green':item.status_v === 1,
                    'sel-status-yellow':item.status_v === 2,
                    'sel-status-deleted':item.status_v === 3,
                    'sel-status-setting':item.status_v === 4
                    }">
                    <span class="dir-icon" [ngClass]="{
                      'sel-dir-to':item.dir === 0,
                      'sel-dir-from':item.dir === 1
                      }"></span>
                    <span class="sel_name" >
                      {{item.name}}
                    </span>
                  </div>
                </ng-template>

                <!-- custom option template -->
                <ng-template ng-header-tmp>
                  <div *ngIf="sensorProjectList.length > 1 && sensorProjectList.length > sensor_select.length">
                    <span class="select-all-sensors"
                      (click)="toggleSelectAll(sensorProjectList, getSensor, 'sensor_id', sensor_select)">{{ 'select_all' | translate }}</span>
                  </div>
                  <div *ngIf="sensorProjectList.length > 1 && sensorProjectList.length == sensor_select.length">
                    <span class="select-all-sensors"
                      (click)="toggleSelectAll(sensorProjectList, getSensor,'sensor_id', sensor_select)">{{ 'deselect_all' | translate }}</span>
                  </div>
                </ng-template>

                <ng-template ng-loadingspinner-tmp>
                  <div class="added_date" *ngIf="show_found">
                    {{'found' | translate}}: {{sensorProjectList.length}}
                  </div>
                </ng-template>

                <!-- custom text to select field -->
                <ng-template ng-multi-label-tmp let-items="items">
                  <div class="ng-value" *ngIf="items.length == 1" #selname>
                    <span class="ng-value-label">
                      <span class="val-dir" [ngClass]="{
                        'sel-dir-to':selected_dir === 0,
                        'sel-dir-from':selected_dir === 1
                        }"></span>
                      <span class="val-status" [ngClass]="{
                        'sel-status-red':selected_status === 0,
                        'sel-status-green':selected_status === 1,
                        'sel-status-yellow':selected_status === 2,
                        'sel-status-deleted':selected_status === 3,
                        'sel-status-setting':selected_status === 4
                      }"></span>
                      <span class="selected-name">
                        {{selected_name}}
                      </span>
                      <!-- <span class="added_date">{{'added' | translate}} {{selected_date}}</span> -->
                    </span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1 && sensorProjectList.length > items.length">
                    <span class="ng-value-label">
                      {{ 'selected' | translate }}: {{items.length}}
                    </span>
                  </div>
                  <div class="ng-value" *ngIf="sensorProjectList.length >1 && sensorProjectList.length == items.length">
                    <span class="ng-value-label">{{ 'all_sensors' | translate }}</span>
                  </div>
                </ng-template>
                <!-- custom text to select field -->

              </ng-select>
            </div>

            <!-- выбор статуса -->
            <div class="form-group">
              <label class="control-label" for="status_select">{{ 'sensor_status' | translate }}</label>
              <ng-select
                [items]="statusList"
                class="custom status-select"
                [ngClass]="{ 'remove-padding': statusList.length < 2 }"
                bindLabel="name"
                bindValue="code"
                [multiple]="true"
                [closeOnSelect]="false"
                [selectOnTab]="true"
                placeholder
                notFoundText="{{'no_name_status' | translate}}"
                [(ngModel)]="status_select"
                (ngModelChange)="chooseDirStatus(false)"
                id="status_select"
                #getStatus="ngModel">

                <!-- custom option template -->
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div class="sensor-select-option" [ngClass]="{
                    'sel-status-red':item.code === 0,
                    'sel-status-green':item.code === 1,
                    'sel-status-yellow':item.code === 2,
                    'sel-status-deleted':item.code === 3,
                    'sel-status-setting':item.code === 4
                  }">
                    {{item.name}}
                  </div>
                </ng-template>
                <!-- custom option template -->
                <ng-template ng-header-tmp>
                  <div *ngIf="statusList.length > 1 && statusList.length > status_select.length">
                    <span class="select-all-sensors"
                      (click)="toggleSelectAll(statusList, getStatus, 'code', status_select)">{{ 'select_all' | translate }}</span>
                  </div>
                  <div *ngIf="statusList.length > 1 && statusList.length == status_select.length">
                    <span class="select-all-sensors"
                      (click)="toggleSelectAll(statusList, getStatus,'code', status_select)">{{ 'deselect_all' | translate }}</span>
                  </div>
                </ng-template>

                <!-- custom text to select field -->
                <ng-template *ngIf="status_select.length > 1" ng-multi-label-tmp let-items="items">
                  <div class="ng-value" *ngIf="items.length == 1">
                    <span class="ng-value-label">
                      <span class="selected-name" [ngClass]="{
                        'sel-status-red':selected_status === 0,
                        'sel-status-green':selected_status === 1,
                        'sel-status-yellow':selected_status === 2,
                        'sel-status-deleted':selected_status === 3,
                        'sel-status-setting':selected_status === 4
                      }">
                        {{selected_st_name}}
                      </span>
                    </span>
                  </div>
                  <div class="ng-value" *ngIf="statusList.length > items.length">
                    <span class="ng-value-label">
                      <span>{{ 'selected' | translate }}:</span>
                      {{items.length}}
                    </span>
                  </div>
                  <div class="ng-value" *ngIf="statusList.length == items.length">
                    <span class="ng-value-label">{{ 'all_status' | translate }}</span>
                  </div>
                </ng-template>
                <!-- custom text to select field -->

                <!-- custom text to select field -->
                <ng-template *ngIf="status_select.length == 1" ng-label-tmp let-item="item">
                  <div class="sensor-select-option" [ngClass]="{
                    'sel-status-red':item.code === 0,
                    'sel-status-green':item.code === 1,
                    'sel-status-yellow':item.code === 2,
                    'sel-status-deleted':item.code === 3,
                    'sel-status-setting':item.code === 4
                  }">
                    {{item.name}}
                  </div>
                </ng-template>
                <!-- custom text to select field -->

              </ng-select>
            </div>

            <!-- выбор направления -->
            <div class="form-group">
              <label class="control-label">{{ 'beam_direction' | translate }}</label>
              <ng-select
                [items]="dirList"
                class="custom"
                [ngClass]="{ 'remove-padding': dirList.length < 2 }"
                bindLabel="name"
                bindValue="code"
                [multiple]="true"
                [closeOnSelect]="false"
                [selectOnTab]="true"
                placeholder
                notFoundText="{{'no_name_dir' | translate}}"
                [(ngModel)]="dir_select"
                (ngModelChange)="chooseDirStatus(false)"
                id="dir_select"
                #getDir="ngModel">

                <!-- custom option template -->
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div class="sensor-select-option" [ngClass]="{
                    'd-sel-dir-to':item.code === 0,
                    'd-sel-dir-from':item.code === 1
                  }">
                    {{item.name}}
                  </div>
                </ng-template>
                <!-- custom option template -->

                <!-- custom text to select field -->
                <ng-template *ngIf="dir_select.length > 1" ng-multi-label-tmp let-items="items">
                  <div class="ng-value" *ngIf="dirList.length > items.length">
                    <span class="ng-value-label">
                      <span>{{ 'selected' | translate }}:</span>
                      {{items.length}}
                    </span>
                  </div>
                  <div class="ng-value" *ngIf="dirList.length == items.length">
                    <span class="ng-value-label">{{ 'all_dirs' | translate }}</span>
                  </div>
                </ng-template>
                <!-- custom text to select field -->

                <!-- custom text to select field -->
                <ng-template *ngIf="dir_select.length == 1" ng-label-tmp let-item="item">
                  <div class="sensor-select-option" [ngClass]="{
                    'd-sel-dir-to':item.code === 0,
                    'd-sel-dir-from':item.code === 1
                  }">
                    {{item.name}}
                  </div>
                </ng-template>
                <!-- custom text to select field -->
                <ng-template ng-header-tmp>
                  <div *ngIf="dirList.length > 1 && dirList.length > dir_select.length">
                    <span class="select-all-sensors"
                      (click)="toggleSelectAll(dirList, getDir, 'code', dir_select)">{{ 'select_all' | translate }}</span>
                  </div>
                  <div *ngIf="dirList.length > 1 && dirList.length == dir_select.length">
                    <span class="select-all-sensors"
                      (click)="toggleSelectAll(dirList, getDir,'code', dir_select)">{{ 'deselect_all' | translate }}</span>
                  </div>
                </ng-template>

              </ng-select>
            </div>

            <div class="all-link-box">
              <a (click)="selectAll('')">{{ 'mark_all' | translate }}</a>
              <a (click)="selectAll('un')">{{ 'unmark_all' | translate }}</a>
            </div>

            <div class="buttons-right">
              <button (click)="defaultFilter()" class="filter-btn-default">
                {{ 'default' | translate }}
              </button>
              <button [disabled]="fb_disabled" (keyup.enter)="applyFilterNew()" (click)="applyFilterNew()"
                class="button-active">
                {{ 'apply' | translate }}
              </button>
            </div>

          </div>
        </div>
        <!-- вкладка фильтра датчиков -->

      </div>
      <!-- /развернутый -->
      <div class="mf-arrow-box">
        <div class="mf-arrow" [ngClass]="{'mf-arrow-up': filters_show, 'mf-arrow-down': !filters_show}"
          (click)="toggleFilter(false)"></div>
      </div>
    </div>

    <!-- *** /новый фильтр *** -->

  </div>
  <div *ngIf="warning" class="main-content-box">
    <app-no-access [text]="text_no_access"></app-no-access>
  </div>

</div>